import React, { createContext, useState, useContext } from "react";

const SpinnerContext = createContext(null);

export const SpinnerProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);

  const show = () => setVisible(true);
  const hide = () => setVisible(false);

  return (
    <SpinnerContext.Provider value={{ show, hide }}>
      {visible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/60">
          <div className="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
        </div>
      )}
      {children}
    </SpinnerContext.Provider>
  );
};

export const useSpinner = () => useContext(SpinnerContext);
